import { render, staticRenderFns } from "./dialog-link-entities.vue?vue&type=template&id=bef3b7e8&"
import script from "./dialog-link-entities.vue?vue&type=script&lang=js&"
export * from "./dialog-link-entities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports